module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us page-meet-team"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('MeetDoc', {
    attrs: {
      "props": _vm.props.acf.doc
    }
  }), _c('MeetTeam', {
    attrs: {
      "props": _vm.props.acf.team
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce00223","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/meet-the-team/meet-the-team.pug
// module id = 666
// module chunks = 1